export function getQuoteMock() {
  return [
    {
      documents: [
        {
          createTime: "2026-04-16T10:31:27.409178094",
          id: "Quote|Q6D600026.pdf",
          mediaType: "application/pdf",
          name: "Q6D600026.pdf",
          size: 307866,
        },
      ],
      offer: {
        creationTime: "2026-04-16T10:31:26.888338574",
        id: "32769e4d-de9c-450b-a0aa-8e61ee9d34ec",
        product: {
          antitheftRequirement: "PER REQUIREMENT",
          carHire: "None",
          coverType: "Comprehensive",
          excess: 14200,
          insuredValue: "Market Value",
          premiumTotal: {
            amount: 3573.67,
            currency: "ZAR",
          },
          productName: "Guard",
          quoteNumber: 1,
          referenceNumber: "Q6D600026",
        },
        status: "PENDING",
      },
      request: {
        brokerCode: "TIMDIRECT",
        consentForITC: true,
        dealerCode: "TIMDIRECT",
        policyHolder: {
          cellNumber: "0780998593",
          dateOfBirth: "1988-03-06",
          email: "chule.majeke@toyota-fssa.co.za",
          employmentStatus: "E",
          firstname: "Sthembiso",
          gender: "M",
          idNumber: "8803065956087",
          idType: "1",
          maritalStatus: "M",
          surname: "Masondo",
          title: "MR",
          residentialAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
          },
        },
        quickQuote: false,
        regularDriver: {
          licence: {
            accidentTheftClaimFreeYears: "",
            firstIssueDate: "2020-01-01",
            haveCurrentInsurance: false,
            licenceCode: "B",
            licenceType: "1",
            ncb: "",
          },
          person: {
            cellNumber: "0780998593",
            dateOfBirth: "1988-03-06",
            email: "chule.majeke@toyota-fssa.co.za",
            employmentStatus: "E",
            firstname: "Sthembiso",
            gender: "M",
            idNumber: "8803065956087",
            idType: "1",
            maritalStatus: "M",
            surname: "Masondo",
            title: "MR",
          },
          regularDriverThePolicyHolder: true,
          relationshipToPolicyHolder: "",
        },
        source: "APP",
        vehicle: {
          dayParkingAddress: {
            address1: "",
            address2: "",
            address3: "",
            suburb: "",
            parkingLocation: "M",
            parkingMethod: "10",
          },
          make: "03",
          mnmCode: "05011460",
          model: "BQ",
          nightParkingAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
            parkingLocation: "R",
            parkingMethod: "6",
          },
          paintColor: "210",
          useType: "02",
          vehicleStatus: "N",
          year: 2024,
        },
      },
      externalId: "Q6D600026",
      type: "TELESURE_STANDARD",
    },
    {
      documents: [
        {
          createTime: "2026-04-16T10:31:27.409178094",
          id: "Quote|Q6D600026.pdf",
          mediaType: "application/pdf",
          name: "Q6D600026.pdf",
          size: 307866,
        },
      ],
      offer: {
        creationTime: "2026-04-16T10:31:26.888764882",
        id: "2e1453a0-9868-4041-b668-6836e12515aa",
        product: {
          antitheftRequirement: "PER REQUIREMENT",
          carHire: "Optional",
          coverType: "Comprehensive",
          excess: 5000,
          basicExcessDescription: "5% of claim, or minimum R2500",
          insuredValue: "Retail Value",
          premiumTotal: {
            amount: 2759.0,
            currency: "ZAR",
          },
          productName: "Guardian",
          quoteNumber: 3,
          referenceNumber: "Q6D600026",
          thirdPartyLiabilityCover: "2500000",
          vapSureId: "3c32865f-fc14-46a8-9d19-3edbb67ae516",
        },
        status: "PENDING",
      },
      request: {
        brokerCode: "TIMDIRECT",
        consentForITC: true,
        dealerCode: "TIMDIRECT",
        policyHolder: {
          cellNumber: "0780998593",
          dateOfBirth: "1988-03-06",
          email: "chule.majeke@toyota-fssa.co.za",
          employmentStatus: "E",
          firstname: "Sthembiso",
          gender: "M",
          idNumber: "8803065956087",
          idType: "1",
          maritalStatus: "M",
          surname: "Masondo",
          title: "MR",
          residentialAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
          },
        },
        quickQuote: false,
        regularDriver: {
          licence: {
            accidentTheftClaimFreeYears: "",
            firstIssueDate: "2020-01-01",
            haveCurrentInsurance: false,
            licenceCode: "B",
            licenceType: "1",
            ncb: "",
          },
          person: {
            cellNumber: "0780998593",
            dateOfBirth: "1988-03-06",
            email: "chule.majeke@toyota-fssa.co.za",
            employmentStatus: "E",
            firstname: "Sthembiso",
            gender: "M",
            idNumber: "8803065956087",
            idType: "1",
            maritalStatus: "M",
            surname: "Masondo",
            title: "MR",
          },
          regularDriverThePolicyHolder: true,
          relationshipToPolicyHolder: "",
        },
        source: "APP",
        vehicle: {
          dayParkingAddress: {
            address1: "",
            address2: "",
            address3: "",
            suburb: "",
            parkingLocation: "M",
            parkingMethod: "10",
          },
          make: "03",
          mnmCode: "05011460",
          model: "BQ",
          nightParkingAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
            parkingLocation: "R",
            parkingMethod: "6",
          },
          paintColor: "210",
          useType: "02",
          vehicleStatus: "N",
          year: 2024,
        },
      },
      externalId: "Q6D600026",
      type: "TELESURE_STANDARD",
    },
    {
      documents: [
        {
          createTime: "2026-04-16T10:31:27.409178094",
          id: "Quote|Q6D600026.pdf",
          mediaType: "application/pdf",
          name: "Q6D600026.pdf",
          size: 307866,
        },
      ],
      offer: {
        creationTime: "2026-04-16T10:31:26.888747988",
        id: "5e453b7e-814a-4e0f-8749-3ae907167723",
        product: {
          antitheftRequirement: "PER REQUIREMENT",
          carHire: "Optional",
          coverType: "Comprehensive",
          excess: 5000,
          basicExcessDescription: "5% of claim, or minimum R2500",
          insuredValue: "Retail Value",
          premiumTotal: {
            amount: 2811.0,
            currency: "ZAR",
          },
          productName: "Protector",
          quoteNumber: 2,
          referenceNumber: "Q6D600026",
          thirdPartyLiabilityCover: "2500000",
          vapSureId: "bf867977-ba15-4998-ae22-e58edbcbe50e",
        },
        status: "PENDING",
      },
      request: {
        brokerCode: "TIMDIRECT",
        consentForITC: true,
        dealerCode: "TIMDIRECT",
        policyHolder: {
          cellNumber: "0780998593",
          dateOfBirth: "1988-03-06",
          email: "chule.majeke@toyota-fssa.co.za",
          employmentStatus: "E",
          firstname: "Sthembiso",
          gender: "M",
          idNumber: "8803065956087",
          idType: "1",
          maritalStatus: "M",
          surname: "Masondo",
          title: "MR",
          residentialAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
          },
        },
        quickQuote: false,
        regularDriver: {
          licence: {
            accidentTheftClaimFreeYears: "",
            firstIssueDate: "2020-01-01",
            haveCurrentInsurance: false,
            licenceCode: "B",
            licenceType: "1",
            ncb: "",
          },
          person: {
            cellNumber: "0780998593",
            dateOfBirth: "1988-03-06",
            email: "chule.majeke@toyota-fssa.co.za",
            employmentStatus: "E",
            firstname: "Sthembiso",
            gender: "M",
            idNumber: "8803065956087",
            idType: "1",
            maritalStatus: "M",
            surname: "Masondo",
            title: "MR",
          },
          regularDriverThePolicyHolder: true,
          relationshipToPolicyHolder: "",
        },
        source: "APP",
        vehicle: {
          dayParkingAddress: {
            address1: "",
            address2: "",
            address3: "",
            suburb: "",
            parkingLocation: "M",
            parkingMethod: "10",
          },
          make: "03",
          mnmCode: "05011460",
          model: "BQ",
          nightParkingAddress: {
            address1: "15 Spartan House",
            address2: "Spartan Crescent",
            address3: "",
            postalCode: 2146,
            suburb: "SANDTON",
            parkingLocation: "R",
            parkingMethod: "6",
          },
          paintColor: "210",
          useType: "02",
          vehicleStatus: "N",
          year: 2024,
        },
      },
      externalId: "Q6D600026",
      type: "TELESURE_STANDARD",
    },
  ];
}
